import React from 'react'
import Alert from '@mui/material/Alert'

export default function ErrorMessage({error, ...props}){
  React.useEffect(() => { if (error) console.error(error) }, [error])
  if (error instanceof Error) error = `${error.message}`
  if (error) return <Alert severity="error" {...props}>{error}</Alert>
}
